export default __webpack_public_path__ + "static/horta-82551d86b05c85ccdaad7273bae946ca.jpg";